module.exports = __webpack_public_path__ + "media/messaging.905dc89a.mp4";